"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResourceString = exports.tryParseIsoDateString = exports.toJson = void 0;
const Extensions_1 = require("../Utilities/Extensions");
const Validate_1 = require("../Utilities/Validate");
const resources_1 = __importDefault(require("../resources"));
const isoDateRegex = /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2})(?:\.(\d*))?Z$/;
const dateSerializerOmitsDecimals = !JSON.stringify(new Date(100)).match(/\.100Z"$/);
function toJson(value) {
    return JSON.stringify(value, function (key, stringifiedValue) {
        if (dateSerializerOmitsDecimals && this && (0, Extensions_1.isDate)(this[key])) {
            const msec = this[key].getMilliseconds(), msecString = String(msec + 1000).substring(1);
            const replacer = function (all, datetime) {
                return datetime + "." + msecString + "Z";
            };
            return stringifiedValue.replace(isoDateRegex, replacer);
        }
        else {
            return stringifiedValue;
        }
    });
}
exports.toJson = toJson;
function tryParseIsoDateString(text) {
    (0, Validate_1.isString)(text);
    const matchedDate = isoDateRegex.exec(text);
    if (matchedDate) {
        const parsed = Date.parse(text);
        const dateObj = new Date(parsed);
        return dateObj;
    }
    return null;
}
exports.tryParseIsoDateString = tryParseIsoDateString;
function getResourceString(resourceName) {
    return resources_1.default[resourceName];
}
exports.getResourceString = getResourceString;
exports.default = {
    getResourceString,
    tryParseIsoDateString,
    toJson,
};
